<template>
  <v-data-table
    dense
    no-data-text="Nothing to see here..."
    no-results-text="You filtered a little too hard there bud..."
    :headers="measurementHeaders"
    :items="measurements"
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-icon left>fas fa-vial</v-icon>
          QC Information {{ rawTitle }}
        </v-toolbar-title>
        <v-spacer/>
        <QualityRawMeasrementForm
          v-if="isDetailed"
          :is-duplicate="false"
          :is-edit="false"
          :rawmaterialid="rawid"
        />
      </v-toolbar>
    </template>
    <template v-slot:item.rawmaterial.barcode="{ item }" v-if="isDetailed">
      <v-btn
        small
        outlined
        color="primary"
        :to="{
          name: 'MaterialBatches',
          params: { id: item.rawmaterial.material_id }
        }"
      >
        {{ item.rawmaterial.barcode }}
      </v-btn>
    </template>
    <template v-slot:item.action="{ item }" v-if="isDetailed">
      <QualityRawMeasrementForm
        :is-edit="true"
        :is-duplicate="false"
        :rawmaterialid="rawid"
        :instance="item"
      />
      <QualityRawMeasrementForm
        :is-edit="false"
        :is-duplicate="true"
        :rawmaterialid="rawid"
        :instance="item"
      />
      <QualityMeasurementDeleteForm
        :instance="item"
      />
    </template>
  </v-data-table>
</template>

<script>
import QualityRawMeasrementForm from "./QualityRawMeasurementForm";
import QualityMeasurementDeleteForm from "./QualityMeasurementDeleteForm";
export default {
  name: "QualityRawMeasurementTable",
  components: { QualityRawMeasrementForm, QualityMeasurementDeleteForm },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    rawid: {
      type: Number,
      required: false
    },
    rawTitle: {
      type: String,
      required: false
    },
    isDetailed: {
      type: Boolean,
      required: true,
      default: false
    },
    measurements: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      measurementHeaders: [
        { text: "Raw Material", sortable: true, value: "rawmaterial.barcode" },
        { text: "ICP", sortable: true, value: "icp" },
        { text: "Analyte", sortable: true, value: "analyte" },
        { text: "Reagent", sortable: true, value: "reagent" },
        { text: "Moisture", sortable: true, value: "ppm_water" },
        { text: "Surface Area", sortable: true, value: "bet" },
        { text: "Density", sortable: true, value: "density" },
        { text: "Notes", sortable: true, value: "note" },
        { text: "Actions", value: "action", align: "center" }
      ]
    };
  }
};
</script>

